import { tv } from 'tailwind-variants';

export const filterCardsVariants = tv({
  slots: {
    wrapper: [
      'flex',
      'flex-col',
      'md:flex-row',
      'gap-4',
      'md:gap-6',
      'my-4',
    ],
    filterSidebar: [
      'hidden',
      'md:flex',
      'md:flex-col',
      'md:w-64',
      'md:shrink-0',
    ],
    filterHeader: [
      'flex',
      'items-center',
      'pb-2.5',
      'border-b-2',
      'border-textPrimary',
      'font-bold',
      'text-lg',
      'flex-none',
      'basis-10',
      'justify-between'
    ],
    filterIcon: [
      'text-lg',
    ],
    filterTitle: [
      'font-bold!',
      'leading-6.75',
      'text-left!',
      'text-lg!',
      'text-textPrimary!'
    ],
    filterCategory: [
      'box-border',
      'block',
      'text-base',
      'font-medium',
      'leading-6',
      'text-left',
      'text-textPrimary',
      'mb-7.5',
      'md:mb-0'
    ],
    filterCategoryTitle: [
      'box-border',
      'block',
      'mb-4',
      'md:mt-8',
      'font-bold!',
      'text-2xl!',
      'leading-7.25',
    ],
    filterCheckboxList: [
      'flex',
      'flex-col',
      'gap-4',
    ],
    filterCheckboxLabel: [
      'font-light',
      'flex',
      'text-lg',
      'leading-5.75',
      'text-left',
      'gap-2.5',
      'select-none',
      'text-textPrimary',
      'items-center'
    ],
    filterCheckbox: [
      'w-5',
      'h-5',
      'shrink-0',
      'relative',
      'appearance-none',
      'border-2',
      'border-[#aaa]',
      'rounded-[3px]',
      'bg-white',
      'cursor-pointer',
      'transition-colors',
      'duration-150',
      'checked:bg-dark-green',
      'checked:border-dark-green',
      'after:content-[""]',
      'after:hidden',
      'after:absolute',
      'after:left-1.5',
      'after:top-0.5',
      'after:w-1.5',
      'after:h-2.5',
      'after:border-r-2',
      'after:border-b-2',
      'after:border-white',
      'after:rotate-45',
      'checked:after:block',
    ],
    clearSelectionsButton: [
      'text-secondary',
      'underline',
      'text-base',
      'cursor-pointer',
      'hover:text-primary',
      'bg-transparent',
      'border-none',
      'text-left',
      'decoration-solid',
      'decoration-0',
      'leading-6',
      'font-bold',
    ],
    mainContent: [
      'flex-1',
      'min-w-0',
    ],
    resultsHeader: [
      'flex',
      'items-center',
      'justify-between',
      'pb-2.5',
      'border-b-2',
      'border-textPrimary',
      'md:justify-end',
      'mt-4',
      'md:mt-0'
    ],
    resultsCount: [
      'text-textPrimary',
      'font-bold',
      'text-lg',
      'leading-6.75',
      'text-left'
    ],
    mobileFilterButton: [
      'flex',
      'items-center',
      'box-border',
      'shrink',
      'justify-center',
      'px-3',
      'py-3',
      'text-lg',
      'font-bold',
      'leading-6.75',
      'text-left',
      'text-primary',
      'bg-white',
      'border-2',
      'border-solid',
      'border-primary',
      'rounded-sm',
      'transition-colors',
      'duration-150',
      'ease-in',
      'w-full',
      'mb-2.5',
      'gap-1.25',
      'md:hidden'
    ],
    cardGrid: [
      'grid',
      'grid-cols-1',
      'md:grid-cols-2',
      'gap-6',
      'pt-8'
    ],
    card: [
      'box-border',
      'flex',
      'flex-col',
      'overflow-hidden',
      'font-medium',
      'text-base',
      'leading-6',
      'text-left',
      'text-textPrimary',
      'border',
      'border-medium-gray',
      'transition-shadow',
      'duration-200',
      'ease-in-out',
      'hover:shadow-[0_3px_12px_rgba(0,0,0,0.1)]'
    ],
    cardTopBar: [
      'h-1.5',
      'w-full',
      'bg-primary'
    ],
    cardImageWrapper: [
      'w-31.75',
      'h-31.75',
    ],
    cardBody: [
      'flex',
      'flex-col',
      'flex-1',
      'items-center',
      'w-full',
    ],
    cardContent: [
      'flex',
      'flex-col',
      'flex-1',
      'box-border',
      'w-full',
      'px-6',
    ],
    cardTags: [
      'flex',
      'flex-wrap',
      'gap-1.5',
      'items-center',
      'justify-center'
    ],
    cardTag: [
      'text-xs',
      'leading-3',
      'font-semibold',
      'uppercase',
      'px-2.5',
      'py-1',
      'text-center',
      'uppercase',
      'rounded-sm'
    ],
    cardTitle: [
      'box-border',
      'block',
      'mt-5',
      'mb-2.5',
      'font-bold!',
      'text-[20px]!',
      'text-textPrimary!',
      'text-center',
      'leading-6!'
    ],
    cardDescription: [
      'text-lg',
      'font-light',
      'leading-6.75',
      'text-center',
      'text-light-black'
    ],
    cardCtaWrapper: [
      'flex',
      'mt-auto',
      'w-full',
      'px-6',
      'pb-7.5',
    ],
    paginationWrapper: [
      'flex',
      'items-center',
      'justify-center',
      'gap-2.5',
      'my-9',
    ],
    pages: [
      'border-2',
      'border-solid',
      'border-light-gray',
      'text-textPrimary',
      'hover:border-call-out',
      'hover:text-call-out',
      'transition-colors',
    ],
    paginationButton: [
      'w-9.5',
      'h-9.5',
      'flex',
      'items-center',
      'justify-center',
      'rounded',
      'cursor-pointer',
      'font-bold',
      'text-[14px]',
      'hover:text-secondary'
    ],
    paginationButtonActive: [
      'bg-secondary',
      'text-white',
      'border-primary',
    ],
    paginationEllipsis: [
      'px-2',
    ],
    mobileModal: [
      'fixed',
      'inset-0',
      'z-50',
      'bg-white',
      'flex',
      'flex-col',
      'overflow-auto',
      'z-10002'
    ],
    mobileModalHeader: [
      'flex',
      'items-center',
      'justify-between',
      'px-10',
      // 'py-6.25',
      'border-b',
      'border-light-gray',
      'sticky',
      'top-0',
      'bg-white',
    ],
    mobileModalTitle: [
      'text-primary!',
      'font-semibold!',
      'text-[27px]!',
      'leading-[32.4px]!',
      'my-6.25!'
    ],
    mobileModalCloseButton: [
      'box-border',
      'block',
      'px-2',
      'py-1',
      'text-[20px]',
      'text-[#555]'
    ],
    mobileModalContent: [
      'flex-1',
      'overflow-auto',
      'pt-5',
      'pb-10',
      'px-10'
    ],
    mobileModalFooter: [
      'px-10',
      'py-4',
      'border-t',
      'border-light-gray',
      'sticky',
      'bottom-0',
      'bg-white',
      'flex',
      'gap-3'
    ],
    applyFiltersButton: [
      'w-full',
      'py-3',
      'bg-primary',
      'text-white',
      'font-semibold',
      'rounded',
      'cursor-pointer',
      'hover:bg-tertiary',
      'transition-colors',
      'border-none',
    ],
    clearButton: [
      'w-full',
      'py-3',
      'px-5',
      'bg-white',
      'font-semibold',
      'rounded',
      'cursor-pointer',
      'hover:bg-tertiary',
      'transition-colors',
      'border-primary',
      'border-2',
      'text-primary',
      'basis-0',
    ],
  },
  variants: {
    layout: {
      'full-column': {
        cardGrid: [
          'md:grid-cols-1',
        ],
        cardTitle: ['text-left'],
        cardTopBar: ['hidden!'],
        cardImageWrapper: ['hidden!'],
        cardContent: ['pt-6!', 'items-start'],
        cardDescription: ['text-left!'],
        cardTags: ['justify-start', 'items-start']
        // card: ['']
      },
      'two-column': {
        cardBody: ['pt-5'],
        cardGrid: [
          'md:grid-cols-2',
        ],
        cardContent: ['pt-7.5', 'items-center']
      },
    },
    hasTopBar: {
      true: {
        cardTopBar: [
          'block',
        ],
      },
      false: {
        cardTopBar: [
          'hidden',
        ],
      },
    },
  },
  defaultVariants: {
    layout: 'two-column',
    hasTopBar: true,
  },
});
